import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { loginWithGoogle } = useAuth();

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6 bg-[#111827]"
      style={{ backgroundImage: "radial-gradient(ellipse 70% 50% at 50% -10%, rgba(13,148,136,0.22), transparent), radial-gradient(ellipse 50% 40% at 85% 110%, rgba(13,148,136,0.10), transparent)" }}
    >
      <div className="w-full max-w-md bg-white/[0.04] backdrop-blur-xl border border-white/10 rounded-sm p-8 shadow-2xl fade-up">
        <div className="mb-8">
          <img src="/cashline-logo-white.png" alt="Cashline" className="h-11 w-auto" data-testid="login-logo" />
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#94A3B8] mt-3">Cash Flow Management</p>
        </div>

        <Button data-testid="google-login-btn" type="button" onClick={loginWithGoogle} variant="outline" className="w-full h-11 rounded-sm bg-white border-transparent hover:bg-[#F1F5F9] text-[#0F172A] font-medium">
          <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          Prijavi se Google računom
        </Button>

        <p className="mt-5 text-xs text-center text-[#94A3B8]" data-testid="access-restricted-note">
          Pristup imaju samo ovlašteni korisnici.
        </p>
      </div>
    </div>
  );
}
